import React, { useEffect } from "react";

/**
 * Lightweight per-page SEO — updates <title>, description, and OG tags on route change.
 */
export default function SEO({
    title = "Acumen Financial Services | UK Mortgage & Protection Advisory",
    description = "From first keys to future wealth. UK-based mortgage, protection and commercial finance advisory — personalised, transparent, compliant advice.",
    path = "",
}) {
    useEffect(() => {
        document.title = title;

        const set = (selector, attr, value) => {
            let el = document.head.querySelector(selector);
            if (!el) {
                el = document.createElement("meta");
                const [key, val] = selector
                    .replace("meta[", "")
                    .replace("]", "")
                    .split("=");
                el.setAttribute(key, val.replace(/['"]/g, ""));
                document.head.appendChild(el);
            }
            el.setAttribute(attr, value);
        };

        set('meta[name="description"]', "content", description);
        set('meta[property="og:title"]', "content", title);
        set('meta[property="og:description"]', "content", description);
        set('meta[name="twitter:title"]', "content", title);
        set('meta[name="twitter:description"]', "content", description);

        // canonical
        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute(
            "href",
            `${window.location.origin}${path || window.location.pathname}`
        );
    }, [title, description, path]);

    return null;
}
